/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from "react";
import PropTypes from "prop-types";
import PlusIcon from "../../assets/img/icons/icon-plus-white.svg";

function AddTrigger({ addWorkflowStep, event }) {
  const [showContext, setShowContext] = React.useState(false);
  const onPlusClick = () => setShowContext(!showContext);
  const hideMenu = () => setShowContext(false);

  const handleOnclick = React.useCallback(() => {
    addWorkflowStep(event);
  }, [addWorkflowStep, event]);

  return (
    <div className="pp_trigger_add_button_holder">
      <button
        type="button"
        className="pp_trigger_add_button"
        onClick={onPlusClick}
        onBlur={hideMenu}
      >
        <PlusIcon fill="#ffffff" width="29" height="30" />
      </button>
      {showContext ? (
        <ul className="pp_trigger_add_context_menu">
          <li onMouseDown={handleOnclick}> Add Email</li>
        </ul>
      ) : null}
      <span className="pp_trigger_add_message">ADD MESSAGE</span>
    </div>
  );
}

AddTrigger.propTypes = {
  addWorkflowStep: PropTypes.func.isRequired,
  event: PropTypes.string.isRequired,
};
export default AddTrigger;
